import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { FormControlProps } from './FormControl'

export type FormControlWrapperProps = Omit<FormControlProps, 'className' | 'children'>

export const FormControlWrapper = styled.div<FormControlWrapperProps>`
  margin-bottom: ${Spacing.S8};
  ${({ flex }) => flex && `flex: ${flex};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight};`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ padding }) => padding && `padding: ${padding};`}
  ${({ width }) => width && `width: ${width};`}

  .for-select {
    padding-right: ${Spacing.S24};
  }
`
